import { CounsellorsConstants } from "../constants";

const initialstate = {
  loading: false,
  CounsellorRequest: false,
  counsellorSuccess: false,
  counsellorFailure: false,
  items: [],
  selectedCounsellor:'',
  response:''
};

export function counsellors(state = initialstate, action) {
  switch (action.type) {
    case CounsellorsConstants.GETCOUNSELLORS_REQUEST:
      return {
        ...state,
        loading: true,
        CounsellorRequest: true,
        counsellorFailure: false,
        counsellorSuccess: false,
        counsellors: action.response,
      };
    case CounsellorsConstants.GETCOUNSELLORS_SUCCESS:
      return {
        ...state,
        items: action.payload,
        loading: false,
        CounsellorRequest: false,
        counsellorFailure: false,
        counsellorSuccess: true,
        counsellors: action.counsellors,
      };
    case CounsellorsConstants.GETCOUNSELLORS_FAILURE:
      return {
        ...state,
        loading: false,
        CounsellorRequest: false,
        counsellorSuccess: false,
        counsellorFailure: true,
        counsellors: action.response,
      };

      case CounsellorsConstants.CREATECOUNSELLORS_REQUEST:
      return {
        ...state,
        loading: true,
        CounsellorRequest: true,
        counsellorFailure: false,
        counsellorSuccess: false,
        message: ''
      };
    case CounsellorsConstants.CREATECOUNSELLORS_SUCCESS:
      return {
        ...state,
        items: action.payload,
        loading: false,
        CounsellorRequest: false,
        counsellorFailure: false,
        counsellorSuccess: true,
        message: action.counsellors,
      };
    case CounsellorsConstants.CREATECOUNSELLORS_FAILURE:
      return {
        ...state,
        loading: false,
        CounsellorRequest: false,
        counsellorSuccess: false,
        counsellorFailure: true,
        message: action.data,
      };
    case CounsellorsConstants.SELECTED_COUNSELLOR:
      return{
          ...state,
          selectedCounsellor:action.id
      }
    case CounsellorsConstants.RESET_COUNSELLOR:
      return{
        ...state,
        selectedCounsellor:''
        }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/counsellors.reducer.js